<template>
    <div>

        <config-main-title>
            Pacotes de Sessões
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-filter" 
                            type="select" 
                            optionsMode="esp-ativas"
                            optionsName="esp-ativas"
                            placeholder="Todas"
                            v-model="especialidade" />
                </div>
                <div class="col col-12 col-md-3">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir Pacote de Sessão
                    </button>
                </div>
            </div>

        </div>

        <template v-if="!em_edicao">

            <div v-if="!lista || !lista.length">
                <az-empty-state 
                    msg="Nenhum pacote de sessão identificado." 
                    icon="fas fa-search"
                    action="Incluir Pacote" 
                    :method="incluir" />
            </div>

            <div v-if="lista && lista.length">

                <div class="list-group mb-3 az-anime-surgir mb-3">
                    <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                        <span>
                            <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                                {{ dado.search }}
                            </a>

                            <span class="badge badge-secondary ml-3">#{{ dado.id_pacote }}</span>
                        </span>
                        <span>
                            <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                                <input type="checkbox" class="custom-control-input" 
                                    :id="'ativo-' + id" 
                                    v-model="dado.fl_ativo" 
                                    @change="toggle(dado)">
                                <label class="custom-control-label" :for="'ativo-' + id"></label>
                            </div>
                            <span v-else>
                                <template v-if="dado.fl_particular">
                                    <span v-if="dado.dc_valor">
                                        R$ {{ format (dado.dc_valor) }}
                                    </span>
                                </template>
                                <template v-else>
                                    <div class="d-flex" v-if="dado.pacote_operadoras.length">
                                        <span class="d-inline-block text-truncate mr-2" style="max-width: 220px;">
                                            {{ listaOperadoras (dado) }}
                                        </span>
                                        <h4 class="mb-0" >
                                            <span class="badge badge-secondary" >
                                                {{ dado.pacote_operadoras.length }}
                                            </span>
                                        </h4>
                                    </div>
                                    <span v-else>
                                        Todas as Operadoras
                                    </span>
                                </template>
                            </span>
                        </span>
                    </li>
                </div>

            </div>

            <az-wiki topic="Pacote" />

        </template>

        <!-- Formulário de edição de pacote de sessão -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_pacote ? '' : 'Novo' }}
                            Pacote de Sessão
                            <span class="badge badge-secondary ml-2" v-if="item && item.id_pacote">
                                #{{ item.id_pacote }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col">
                                <az-input
                                    sizing="sm"
                                    label="Título"
                                    placeholder="Informar..."
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col">
                                <az-input
                                    sizing="sm"
                                    label="Procedimento"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    optionsName="procedimentos.index" 
                                    service="procedimentos.index"
                                    :optionsSync="false"
                                    required 
                                    :validate="validate"
                                    v-model="item.procedimento_pacote.procedimento"
                                    :edicao="!item.id_pacote" />
                            </div>
                        </div>
                        <div class="form-row mt-3">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Particular"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_particular" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="!item.fl_particular">
                                <az-input
                                    sizing="sm"
                                    label="Cobrança Total"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_cobranca_total" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Quantidade Variada"
                                    type="checkbox-group"
                                    :edicao="!item.id_pacote"
                                    :validate="validate"
                                    v-model="item.fl_qtde_variada" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Cobrar Mat/Med Separado"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_cobrar_mat_separado" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="!item.fl_particular && item.fl_cobranca_total">
                                <az-input
                                    sizing="sm"
                                    label="Exibir quantidade 1 na guia"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.procedimento_pacote.in_qt_guia" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="!item.fl_particular">
                                <az-input
                                    sizing="sm"
                                    label="Por Unidade"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_por_unidade" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.fl_cobranca_total">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    label="Distribuir itens do pacote no xml de fatura"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_distribuir_itens_xml" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.fl_cobranca_total">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Duração (min)"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_duracao" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.fl_particular">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Permitir pré-pagamento"
                                    type="checkbox-group"
                                    :validate="validate"
                                    v-model="item.fl_pre_pago" />
                            </div>
                        </div>

                        <div class="form-row mt-2">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    :label="item.fl_qtde_variada ? 'Quantidade Máxima de Sessões' : 'Quantidade de Sessões'"
                                    type="number"
                                    required 
                                    :validate="validate"
                                    v-model="item.procedimento_pacote.in_quantidade" 
                                    :edicao="!item.id_pacote" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Validade do Pacote (em dias)"
                                    type="number"
                                    :validate="validate"
                                    v-model="item.in_validade_dias" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Validade Fora Mês"
                                    type="checkbox"
                                    :validate="validate"
                                    v-model="item.fl_valid_fora_mes" />
                            </div>
                        </div>

                        <div class="form-row mt-2" v-if="item.fl_particular">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    :icon="item.fl_qtde_variada ? 'fa-solid fa-square fa-fw' : 'fa-solid fa-layer-group fa-fw'"
                                    :label="item.fl_qtde_variada ? 'Valor da Sessão' : 'Valor do Pacote'"
                                    type="money"
                                    required 
                                    :validate="validate"
                                    v-model="item.dc_valor" />
                                    
                            </div>
                        </div>

                        <template v-if="!item.fl_particular">

                            <az-sub-title class="mt-2" title="Operadoras" />

                            <div class="form-row">
                                
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        name="operadora-pacote"
                                        icon="fas fa-plus"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsParm="{ fatura: true }"
                                        service="operadoras.index"
                                        v-model="pacoteNovaOperadora"
                                        @input="adicionarOperadora ()" />
                                </div>

                                <div class="col col-12 col-md-4" v-for="(po, ipo) in item.pacote_operadoras" :key="ipo">
                                    <az-input
                                        sizing="sm" 
                                        type="checkbox-group"
                                        :label="po.search"
                                        v-model="po.selecionado" />
                                </div>

                                <div class="col col-12 col-md-4" v-if="!item.pacote_operadoras || !item.pacote_operadoras.length">
                                    <az-input 
                                        sizing="sm"
                                        :edicao="false"
                                        value="Todas" />
                                </div>

                            </div>

                        </template>

                        <template v-else>

                            <az-sub-title class="mt-2" title="Valores Diferenciados" />
                                
                            <template v-for="(sessao_valor, isx) in item.pacote_sessao_valores">
                                <div class="form-row" :key="isx" v-if="!sessao_valor.excluido">
                                    <div class="col col-12 col-md-8">
                                        <az-input 
                                            sizing="sm"
                                            type="label"
                                            :label="sessao_valor.plano.search">
                                            <template v-slot:button-pre>
                                                <div class="input-group-prepend">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="sessao_valor.excluido = true">
                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            sizing="sm"
                                            type="money"
                                            v-model="sessao_valor.dc_valor" />
                                    </div>
                                </div>
                            </template>

                            <div class="form-row">
                                
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        icon="fas fa-plus"
                                        type="select"
                                        optionsMode="aql"
                                        :optionsParm="{ where: { id_operadora: 1, fl_ativo: 1 } }"
                                        optionsName="planos.particular"
                                        service="planos.index"
                                        v-model="pacoteNovoPlano"
                                        @input="adicionarPlano (item)" />
                                </div>

                            </div>

                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-outline-secondary" 
                            @click="$util.logAudit('pacote', item.id_pacote)"
                            v-if="item.id_pacote">
                            Log
                        </button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item && item.id_pacote ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzWiki from '../../util/AzWiki.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            procedimentos: null, 
            validate: false,
            especialidade: "",
            search: "", 
            viewMode: "A",
            pacoteNovaOperadora: "",
            pacoteNovoPlano: "", 
        }
    },

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle, 
        AzWiki, 
    },
    
    watch: { 
        especialidade: function () { 
            this.load ();
        }
    },
    
    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.especialidade || item.procedimento_pacote.procedimento.id_especialidade == this.especialidade.id_especialidade ) &&
                        ( !this.search || reg.test(JSON.stringify(item)) );
                })
                .sort((a, b) => { 
                    return a.search > b.search ? 1 : -1 ;
                }) : null;
        }
    },

    methods: { 
        adicionarPlano(item) { 
            if ( !this.pacoteNovoPlano )
                return;

            if ( item.pacote_sessao_valores.find(item => item.id_plano == this.pacoteNovoPlano.id_plano && !item.excluido) ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Particular já selecionado: " + this.pacoteNovoPlano.search,
                    life: 3000
                });
            } else { 
                item.pacote_sessao_valores.push({
                    id_pacote_sessao_valor: null, 
                    id_pacote: item.id_pacote,
                    id_plano: this.pacoteNovoPlano.id_plano, 
                    plano: this.pacoteNovoPlano,
                    dc_valor: 0, 
                    excluido: false, 
                });
            }

            this.pacoteNovoPlano = null;

            this.$nextTick(() => { 
                this.pacoteNovoPlano = "";
            });
        },

        incluir_plano(item) { 
            item.pacote_sessao_valores.push({
                id_pacote: item.id_pacote,
                id_plano: "",
                dc_valor: "", 
            });
        },

        listaOperadoras (pacote) { 
            return pacote.pacote_operadoras.reduce((lista, item) => { 
                    return lista + ( lista ? ", " : "" ) + item.search;
                }, "");
        },
        adicionarOperadora () { 

            if ( this.pacoteNovaOperadora ) { 
                
                this.item.pacote_operadoras.push({
                    id_pacote_operadora: null, 
                    id_pacote: this.item.id_pacote,
                    id_operadora: this.pacoteNovaOperadora.id_operadora,
                    search: this.pacoteNovaOperadora.search,
                    selecionado: true, 
                });

                this.$nextTick (() => { 
                    this.pacoteNovaOperadora =  "";
                });

            }

        },
        incluir () { 
            this.validate = false;

            let item = {
                id_pacote: null, 
                dc_valor: 0, 
                fl_ativo: true,
                fl_combo: false,
                procedimento_pacote: { 
                    in_quantidade: 2,
                    procedimento: null, 
                },
                operadora: { 
                    id_operadora: 1, 
                    search: 'Particular',
                },
                fl_particular: true, 
                fl_cobranca_total: true, 
                fl_qtde_variada: false, 
                pacote_operadoras: [], 
                pacote_sessao_valores: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'pacotes.index',
                    id: 'lista',
                    parms: { 
                        where: { fl_combo: false },
                        cadastro: true,
                        sessoes: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.validate = false;
            this.item = null; 

            this.$nextTick(() => { 
                this.item = _.cloneDeep (item);
                $('#edicaoModal').modal('show');
            });
        },
        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'pacotes',
                func: 'store', 
                dados: this.item, 
                modal: 'edicaoModal',
                reload: true, 
            });

        },
        
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'pacotes.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Pacotes de Sessões", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>
